import { Box, Button, Typography } from '@mui/material'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { IconCmp } from '..'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import { ScrollableTabs } from '..'
import { useNavigate } from 'react-router-dom'
import {
    ChatIcon,
    CheckTick,
    greenCheck,
    LocationOnOutlinedIcon,
    phoneIcon,
} from '../../Assets'
import useAlert from '../../Hooks/useAlert/useAlert'
import { AcceptEndContractAction } from '../../Store/Actions/BuildBidsJobAction'
import styles from './AwardedJobCard.module.css'

const AwardedJobCard = ({ onClick, awardedJobData, messageNotShow, cursorPointerDisabled }) => {
    const {
        label,
        address,
        zipcode,
        job_start_date,
        project_start_date,
        proposals,
        state,
        job_completion_date,
        job_awarded_date,
        slug,
        city,
        budget_amount,
        services
    } = awardedJobData

    console.log(awardedJobData)

    const formatDate = (date) => {
        if (!date) return null
        const d = new Date(date)
        const year = d.getFullYear()
        const month = String(d.getMonth() + 1).padStart(2, '0')
        const day = String(d.getDate()).padStart(2, '0')
        return date ? `${year}-${month}-${day}` : null
    }

    const dispatch = useDispatch()
    const { setAlert } = useAlert()

    const jobCompleteHandler = (e) => {
        e.stopPropagation()
        dispatch(AcceptEndContractAction(slug, setAlert))
    }

    const navigate = useNavigate()
    const sendMessage = () => {
        navigate('/chat', {
            state: {
                userLocation: proposals?.[0]?.user,
            },
        })
    }

    return (
        <>
            <div
                className={styles.card_wrapper}
                onClick={onClick}
                role="button"
                tabIndex={0}
                style={{ cursor: cursorPointerDisabled && 'default' }}
            >
                {/* Job Details Section */}
                <section className={styles.project_wrappper}>
                    <Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography
                                variant="h5"
                                sx={{
                                    fontWeight: 'bold',
                                    color: 'var(--primary-color)',
                                }}
                                className={styles.bidName}
                            >
                                {label}
                            </Typography>
                        </Box>
                        <Box sx={{ margin: '5px 0 ' }}>
                            <Typography
                                sx={{
                                    fontSize: 'small',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <LocationOnOutlinedIcon
                                    fontSize="small"
                                    sx={{
                                        color: 'var(--primary-color)',
                                        marginLeft: '-5px',
                                    }}
                                />
                                {address}, {city?.label}, {state?.label}, {zipcode}
                            </Typography>
                        </Box>
                        <Box sx={{ margin: '5px 0 ' }}>
                            <Typography
                                sx={{
                                    fontSize: 'small',
                                    display: 'flex',
                                    alignItems: 'center',
                                }}
                            >
                                <MonetizationOnIcon
                                    sx={{
                                        marginRight: ' 5px',
                                        color: 'var(--primary-color)',
                                        ml: '-5px',
                                        fontSize: '18px',
                                    }}
                                />
                                {budget_amount}
                            </Typography>
                        </Box>
                    </Box>

                    <Box className={styles.projectDate}>
                        <section>
                            <Typography
                                fontSize="small"
                                sx={{ color: 'var(--textColor)' }}
                            >
                                Job Start Date:
                            </Typography>
                            <Typography fontSize="14px">
                                {formatDate(project_start_date) || 'N/A'}
                            </Typography>
                        </section>
                        <section>
                            <Typography
                                fontSize="small"
                                sx={{ color: 'var(--textColor)' }}
                            >
                                Job Awarded Date:
                            </Typography>
                            <Typography fontSize="14px">
                                {formatDate(job_awarded_date) || 'N/A'}
                            </Typography>
                        </section>
                        <section>
                            <Typography
                                fontSize="small"
                                sx={{ color: 'var(--textColor)' }}
                            >
                                Job Completion Date:
                            </Typography>
                            <Typography fontSize="14px">
                                {formatDate(job_completion_date) || job_awarded_date
                                    ? 'Ongoing'
                                    : 'N/A'}
                            </Typography>
                        </section>
                    </Box>
                </section>

                {/* divider */}
                <div className={styles.divider}></div>

                {/* User Details Section */}
                <section className={styles.company_wrappper}>
                    <Box
                        sx={{ display: ' flex', justifyContent: 'space-between' }}
                        className={styles.companyName}
                    >
                        <Box>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 2,
                                }}
                            >
                                <Typography
                                    variant="h5"
                                    sx={{
                                        fontWeight: 'bold',
                                        color: 'var(--primary-color)',
                                    }}
                                >
                                    {proposals?.[0]?.user?.label}
                                </Typography>
                            </Box>
                            <Box sx={{ margin: '5px 0 ' }}>
                                <Typography
                                    sx={{
                                        fontSize: 'small',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    <LocationOnOutlinedIcon
                                        fontSize="small"
                                        sx={{
                                            color: 'var(--primary-color)',
                                            marginLeft: '-5px',
                                        }}
                                    />
                                    {proposals?.[0]?.user?.street_address
                                        ? proposals[0]?.user?.state?.label + ", " + proposals[0]?.user?.city?.label + ", " + proposals[0]?.user?.street_address + ", " + proposals[0]?.user?.zip
                                        : 'New Orleans, LA, 70115'}
                                </Typography>
                            </Box>
                        </Box>

                        {proposals &&
                            proposals?.[0]?.status === 'Complete Requested' ? (
                            !window.location.pathname.includes('awardedproject') && <Button
                                // className={styles.iconBox}
                                onClick={(e) =>
                                    jobCompleteHandler(e)
                                }
                                variant="outlined"
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 1,
                                    backgroundColor: 'transparent',
                                    borderColor: 'var(--primary-color)',
                                    color: '#607d8b',
                                    fontWeight: 'semibold',
                                    fontSize: '12px',
                                    textTransform: 'capitalize',
                                    '&:hover': {
                                        backgroundColor:
                                            'var(--primary-color)',
                                        color: '#fff',
                                    },
                                    position: 'absolute',
                                    top: 8,
                                    right: 10,
                                    padding: '3px 8px'
                                }}
                                disableElevation
                            >
                                Job Complete Request
                                <IconCmp
                                    style={{
                                        backgroundColor: 'var(--primary-color)',
                                        width: '20px',
                                        height: '20px',
                                    }}
                                >
                                    <img width="10px" src={CheckTick} alt="" />
                                </IconCmp>
                            </Button>

                            // <div
                            //     className={styles.proposalStatus}
                            //     onClick={(e) => {
                            //         jobCompleteHandler(e)
                            //     }}
                            // >
                            //     <Typography
                            //         fontWeight={'bold'}
                            //         fontSize={'small'}
                            //         sx={{ color: 'var(--primary-color)' }}
                            //     >
                            //         Job Complete Request
                            //     </Typography>
                            //     <IconCmp
                            //         style={{
                            //             backgroundColor: 'var(--primary-color)',
                            //             width: '30px',
                            //             height: '30px',
                            //         }}
                            //     >
                            //         <img width="14px" src={CheckTick} alt="" />
                            //     </IconCmp>
                            // </div>
                        ) : proposals?.[0]?.status === 'Completed' ? (
                            <div>
                                <img src={greenCheck} alt="" />
                            </div>
                        ) : null}
                    </Box>

                    <div className={styles.projectDate}>
                        <section>
                            <Typography
                                fontSize="small"
                                sx={{ color: 'var(--textColor)' }}
                            >
                                Contact Details:
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 2 }}>
                                <Typography
                                    fontSize="14px"
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: 1,
                                    }}
                                >
                                    <img src={phoneIcon} alt="" />

                                    {proposals?.[0]?.user?.phone
                                        ? proposals[0]?.user?.phone
                                        : '+1 123 123 1234'}
                                </Typography>
                                {!messageNotShow && (
                                    <Typography
                                        fontSize="small"
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 1,
                                            cursor: 'pointer',
                                        }}
                                        onClick={(e) => {
                                            e.stopPropagation()
                                            sendMessage()
                                        }}
                                    >
                                        <img src={ChatIcon} alt="" />
                                        Message
                                    </Typography>
                                )}
                            </Box>
                        </section>
                    </div>


                </section>

            </div>

        </>
    )
}
AwardedJobCard.propTypes = {
    onClick: PropTypes.func.isRequired,
    awardedJobData: PropTypes.shape({
        label: PropTypes.string,
        address: PropTypes.string,
        zipcode: PropTypes.string,
        project_start_date: PropTypes.string,
        proposals: PropTypes.array,
        state: PropTypes.object,
        job_completion_date: PropTypes.string,
        job_awarded_date: PropTypes.string,
        slug: PropTypes.string,
    }).isRequired,
    messageNotShow: PropTypes.bool,
    cursorPointerDisabled: PropTypes.bool,
}

export default AwardedJobCard
